import React, { useEffect, useRef, useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import { Button, InputAdornment } from "@material-ui/core";
import downloadWhite from "images/downloadWhite.svg";
import { CustomTextField } from "containers/gstr2a2bNewEnhancement/Utility/utility";
import Table from "./Table";
import { getProfile } from "containers/gstr6/gstr6a/actions";
import { useDispatch, useSelector } from "react-redux";
import { errorToastMessage } from "utils/errorToast";
import { GSTR2A2BNEW_MSGS } from "Constant/Messages";
import {
  downloadRecoHistoryExcel,
  getPipelineStatus,
  getRecoHistory,
  setPageNoRecoHistory,
  setSearchStr,
} from "../action";

const RecoHistory = (props) => {
  const dispatch = useDispatch();
  const interval = useRef("");
  const debounceTimeout = useRef(null);
  const [search, setSearch] = useState("");
  const [profileList, setProfileList] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const profileData = useSelector((store) => store.gstr6aReducer.profileData);
  const { recoHistoryTableData,searchStr } = useSelector(
    (store) => store.gstr2a2bNewRecoReducer
  );
  async function getProfileData() {
    await dispatch(getProfile());
  }

  const handleDownload = () => {
    if (recoHistoryTableData?.length > 0) {
      dispatch(downloadRecoHistoryExcel(searchStr));
    } else {
      errorToastMessage(GSTR2A2BNEW_MSGS.NO_DOWNLOAD);
    }
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    // setSearch(value);
    dispatch(setSearchStr(value));
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(async () => {
      // await dispatch(getHistoryData(value, pageNo));
      props.getHistoryData(value, pageNo);
      dispatch(setPageNoRecoHistory(1)); // Reset page number to 1 on new search
      console.log("Debounce Call searchStr:", value);
    }, 800);
  };

  // // Helper function to count in-process files
  // const countInProcessFiles = (files) =>
  //   files?.filter(
  //     (item) => !["COMPLETED", "FAILED"].includes(item?.STATUS?.toUpperCase())
  //   )?.length || 0;

  // const getInProcessFileIds = (files) =>
  //   files
  //     ?.filter(
  //       (item) => !["COMPLETED", "FAILED"].includes(item?.STATUS?.toUpperCase())
  //     )
  //     .map((item) => item?.ID) || [];

  // const getHistoryData = async (searchStr = search, pageNoHistory = pageNo) => {
  //   try {
  //     // Clear any previous interval
  //     if (interval.current) {
  //       clearInterval(interval.current);
  //       interval.current = null;
  //     }

  //     // Initial fetch
  //     let fileDataTemp = await dispatch(
  //       getRecoHistory(searchStr, pageNoHistory)
  //     );
  //     let inProcessStatusCount = countInProcessFiles(fileDataTemp);

  //     if (fileDataTemp?.length > 0 && inProcessStatusCount > 0) {
  //       interval.current = setInterval(async () => {
  //         try {
  //           // Fetch updated history
  //           fileDataTemp = await dispatch(
  //             getRecoHistory(searchStr, pageNoHistory)
  //           );
  //           inProcessStatusCount = countInProcessFiles(fileDataTemp);

  //           // Get IDs of in-process files
  //           const inProcessFileIds = getInProcessFileIds(fileDataTemp);

  //           if (inProcessFileIds.length > 0) {
  //             console.log("FileId arrays ::", inProcessFileIds);
  //             await dispatch(getPipelineStatus(inProcessFileIds));
  //           }

  //           if (inProcessStatusCount === 0) {
  //             clearInterval(interval.current);
  //             interval.current = null;
  //             console.log("All files processed.");
  //           }
  //         } catch (error) {
  //           console.error("Polling error:", error);
  //           clearInterval(interval.current);
  //           interval.current = null;
  //         }
  //       }, 10000);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching history data:", error);
  //     errorToastMessage(GSTR2A2BNEW_MSGS.ERROR_FETCHING_HISTORY);
  //   }
  // };

  const handlePageClick = (value) => {
    // setPageNo(value.selected + 1);
    dispatch(setPageNoRecoHistory(value.selected + 1));
    props.getHistoryData(searchStr, value.selected + 1);
  };

  useEffect(() => {
    getProfileData();
  }, []);

  useEffect(() => {
    var profileList =
      profileData && profileData.length > 0
        ? profileData.filter((form) => form.profileType == "GST")
        : [];
    console.log("profileList", profileList);

    let newProfile =
      profileList.length > 0
        ? profileList.map((v) => ({ ...v, label: v.gstin }))
        : [];
    setProfileList(newProfile);
  }, [profileData]);

  useEffect(() => {
    console.log('getHistoryData called from RecoHistory');
    props.getHistoryData();

    return () => {
      if (props.interval.current) {
        clearInterval(props.interval.current);
        props.interval.current = null;
      }
    };
  }, []);

  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-start" }}>
        <div style={{ width: "35%" }}>
          <CustomTextField
            style={{ backgroundColor: "white" }}
            placeholder="Search"
              value={searchStr}
            variant="outlined"
            size="small"
            onChange={handleInputChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>

        <Button
          onClick={handleDownload}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "5px",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
          }}
        >
          <img
            src={downloadWhite}
            alt="Download"
            style={{
              width: "30px",
              height: "20px",
              paddingBottom: "3px",
            }}
          />
          Download
        </Button>
      </div>
      <Table profileData={profileList} handlePageClick={handlePageClick} />
    </>
  );
};

export default RecoHistory;
